(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/overview-hero/assets/javascripts/common/pix-area.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/overview-hero/assets/javascripts/common/pix-area.js');

'use strict';

const _ReactRedux = ReactRedux,
  useDispatch = _ReactRedux.useDispatch;
const Button = svs.ui.ReactButton;
const _svs$components$lbUti = svs.components.lbUtils,
  getGameUrl = _svs$components$lbUti.getGameUrl,
  preventDoubleClick = _svs$components$lbUti.preventDoubleClick;
const _svs$components$sport = svs.components.sport.tipsenShared,
  TipsenModuleGameUrl = _svs$components$sport.TipsenModuleGameUrl,
  actions = _svs$components$sport.actions,
  PARAM_ACTION = _svs$components$sport.PARAM_ACTION,
  PARAM_AMOUNT = _svs$components$sport.PARAM_AMOUNT;
const showDialogAction = svs.components.marketplaceCompetition.services.actions.dialogActions.showDialogAction;
const Pix = svs.components.marketplaceShared.pix.Pix;
const logger = svs.core.log.getLogger('marketplace-competition:overview-hero');
const PixArea = _ref => {
  let branding = _ref.branding,
    competition = _ref.competition,
    isMobile = _ref.isMobile,
    isVisible = _ref.isVisible;
  const dispatch = useDispatch();
  const _ref2 = (competition === null || competition === void 0 ? void 0 : competition.details) || {},
    currentDrawNumber = _ref2.currentDrawNumber,
    productId = _ref2.productId,
    systemNumber = _ref2.systemNumber;
  if (!isVisible) {
    return null;
  }
  const navigateToProductPage = _ref3 => {
    let subPath = _ref3.subPath,
      search = _ref3.search;
    if (productId && currentDrawNumber) {
      const path = getGameUrl({
        productId,
        drawNumber: currentDrawNumber,
        options: {
          subPath,
          search
        }
      });
      if (path) {
        window.location.href = window.location.origin + path;
        return;
      }
    }
    logger.info("Could not create game url, competitionId: ".concat(competition === null || competition === void 0 ? void 0 : competition.id, " productId: ").concat(productId, " currentDrawNumber: ").concat(currentDrawNumber));
    dispatch(showDialogAction({
      title: 'Något gick fel',
      text: 'Vi kunde inte öppna sidan. Försök igen senare.',
      icon: 'exclamation-sign',
      type: 'error',
      buttons: [{
        text: 'Okej'
      }]
    }));
  };
  const handleSettleBetWithPix = () => navigateToProductPage({
    subPath: "/".concat(TipsenModuleGameUrl.PIX),
    search: "".concat(PARAM_ACTION, "=").concat(actions.OPEN_PIX, "&").concat(PARAM_AMOUNT, "=").concat(systemNumber)
  });
  return React.createElement(Pix, {
    branding: branding
  }, React.createElement("div", {
    className: "competition-center-to-screen"
  }, React.createElement(Button, {
    "aria-label": "K\xF6p en PIX",
    className: "buy-pix-button qa-competition-overview-hero-put-xpert-button",
    href: "".concat(getGameUrl({
      productId,
      drawNumber: currentDrawNumber,
      options: {
        subPath: "/".concat(TipsenModuleGameUrl.PIX),
        search: "".concat(PARAM_ACTION, "=").concat(actions.OPEN_PIX, "&").concat(PARAM_AMOUNT, "=").concat(systemNumber)
      }
    })),
    inverted: true,
    onClick: e => {
      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();
      preventDoubleClick(handleSettleBetWithPix);
    },
    size: isMobile ? 100 : 300,
    transparent: true
  }, "K\xF6p en PIX!")));
};
setGlobal('svs.components.marketplaceCompetition.overviewHero.common.PixArea', PixArea);

 })(window);